<h1 mat-dialog-title>App Log</h1>
<mat-dialog-content class="mat-typography" [innerText]="content">
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="exportLog()">Export</button>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
